angular.module("ainapp")
    .controller("adspentReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Adspent Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


              $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Branches = response.data;
                $scope.Branches.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })


            $scope.Brands = [];
            MainService.BrandsInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Brands = response.data;
                $scope.Brands.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })

            $scope.Categories = [];
            MainService.ProductsParentList("Product").then(function (response) {
                $scope.Categories = response.data;
            });

            $scope.GetSub = function () {
                $scope.Parents = [];
                MainService.ProductSubList($scope.filter.ProductGroupId, "Product").then(function (response) {
                    $scope.Parents = response.data;
                });
            }

            $scope.IsSales = true;
            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Employees = response.data;
                $scope.Employees.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })


            $scope.Init = function () {

                $scope.CostCenters = [];
                MainService.CostCentersInReortVoucher("Sales Invoice 2").then(function (response) {
                    $scope.CostCenters = response.data;
                })

                // $('#filterModal').modal('show');
                 var startdate = new Date(new Date().getFullYear(), 0, 1);


                 $scope.filter = {
                    CustomerName: "",
                    BranchId: "",
                    ProductName: "",
                    VoucherNo: "",
                    CustomerId: "",
                    FromDate: startdate,
                    ToDate: new Date(),
                    CustomerIds: [],
                    ProductIds: [],
                    ProductGroupId: "",
                    ProductParentId: "",
                    BrandId: "",
                }


                $scope.load = false;
                $scope.isFilter = false;



            }
            $scope.Init();


             $scope.customerSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.CustomerInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.selectCustomerOptions = {
                placeholder: "Select Accounts...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                filter: "contains",
                autoBind: true,
                dataSource: $scope.customerSelectDataSource
            };


            $scope.productSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.productInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.selectProductOptions = {
                placeholder: "Select Products...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.productSelectDataSource
            };



            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        o.data.FromDateString = $scope.extractDate($scope.filter.FromDate);
                        o.data.ToDateString = $scope.extractDate($scope.filter.ToDate);

                        o.data.CustomerId = $scope.filter.CustomerId;
                        o.data.VoucherNo = $scope.filter.VoucherNo;
                        o.data.ProductId = $scope.filter.ProductId;

                        o.data.CustomerIds = $scope.filter.CustomerIds;
                        o.data.ProductIds = $scope.filter.ProductIds;
                        o.data.BranchId = $scope.filter.BranchId;
                        o.data.CostCenters = $scope.CostCenters;
                        o.data.IsPending = $scope.IsPending;
                        o.data.EmployeeId = $scope.filter.EmployeeId;
                        o.data.ProductGroupId = $scope.filter.ProductGroupId;
                        o.data.ProductParentId = $scope.filter.ProductParentId;
                        o.data.BrandId = $scope.filter.BrandId;



                        MainService.AdsepntReport(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })

                    },

                },
                change: function (data) { },
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "Name": {
                                type: "string",
                                editable: false,
                            },
                            "ParentName": {
                                type: "string",
                                editable: false,
                            },
                            "Quantity": {
                                type: "number",
                                editable: false,
                            },
                            "Amount": {
                                type: "number",
                                editable: false,
                            },
                            "Spent": {
                                type: "number",
                                editable: false,
                            },
                            "AdsQty": {
                                type: "number",
                                editable: false,
                            },
                            "Roas": {
                                type: "number",
                                editable: false,
                            },
                            "SpentPer": {
                                type: "number",
                                editable: false,
                            },
                        }
                    }
                },
                group: [{
                    field: "ParentName",
                    aggregates: [{
                        field: "Quantity",
                        aggregate: "sum"
                    },
                    {
                        field: "Amount",
                        aggregate: "sum"
                    }, {
                        field: "Spent",
                        aggregate: "sum"
                    },
                    {
                        field: "AdsQty",
                        aggregate: "sum"
                    },
                    {
                        field: "Roas",
                        aggregate: "sum"
                    },
                    {
                        field: "SpentPer",
                        aggregate: "sum"
                    }]
                }],
                aggregate: [
                    {
                        field: "Quantity",
                        aggregate: "sum"
                    },
                    {
                        field: "Amount",
                        aggregate: "sum"
                    }, {
                        field: "Spent",
                        aggregate: "sum"
                    },
                    {
                        field: "AdsQty",
                        aggregate: "sum"
                    },
                    {
                        field: "Roas",
                        aggregate: "sum"
                    },
                    {
                        field: "SpentPer",
                        aggregate: "sum"
                    }
                ],
                //                serverPaging: true,
                //                serverSorting: true,
                //                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {
                stretch: true,
                toolbar: ["excel", "pdf"],
                selectable: true,
                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 780,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 1000,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                columns: [
                    {
                        field: "Name",
                        title: "Row Labels"
                    },
                    {
                        field: "Quantity",
                        title: "Sum Of Qty",
                        aggregates: ["sum"],
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        template: "<div style='text-align: right'>#=kendo.toString(Quantity, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>Sum Of Qty</div>")
                    },
                    {
                        field: "Amount",
                        title: "Sum Of Amount",
                        aggregates: ["sum"],
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        template: "<div style='text-align: right'>#=kendo.toString(Amount, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>Sum Of Amount</div>")
                    },
                    {
                        field: "Spent",
                        title: "Spent",
                        aggregates: ["sum"],
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        template: "<div style='text-align: right'>#=kendo.toString(Spent, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>Spent</div>")
                    },
                    {
                        field: "AdsQty",
                        title: "Ads Qty",
                        aggregates: ["sum"],
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        template: "<div style='text-align: right'>#=kendo.toString(AdsQty, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>Ads Qty</div>")
                    },
                    {
                        field: "Roas",
                        title: "Roas",
                        aggregates: ["sum"],
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        template: "<div style='text-align: right'>#=kendo.toString(Roas, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>Roas</div>")
                    },
                    {
                        field: "SpentPer",
                        title: "Spent %",
                        aggregates: ["sum"],
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        template: "<div style='text-align: right'>#=kendo.toString(SpentPer, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>Spent %</div>")
                    },
                ],
            };



            $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.GetReport = function () {
                $scope.isFilter = true;
                $('#filterModal').modal('hide');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.Refresh = function () {
                $scope.Init();
                $scope.isFilter = true;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }



        }])
